import { render, staticRenderFns } from "./insquery.vue?vue&type=template&id=05f54f9c&scoped=true&"
import script from "./insquery.vue?vue&type=script&lang=js&"
export * from "./insquery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f54f9c",
  null
  
)

export default component.exports